import React, { useState, useEffect } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useModuloControle } from "../../contexts/ModuloControleContext";
import { decode as base64_decode } from "base-64";
import { ObterCaminhoDaUrl } from "../Utilitarios/Funcoes";
import MfaChallenge from "../TwoFactor/MfaChallenge";
import { generateDeviceFingerprint } from "../../utils/deviceFingerprint";
import Swal from "sweetalert2";

const AuthGuard = ({ children }) => {
  const {
    primeiroAcesso,
    possuiEmpresas,
    possuiCertificado,
    contaBloqueada,
    podeTestarGestao,
    expirouDemonstracao,
    expirouTesteGestao,
    duplicidadeCadastro,
  } = useModuloControle();
  const validaExpericao = (moduloAtual) => {
    if (expirouDemonstracao) {
      return moduloAtual === 0 ? "/planos" : "/resgate/planos";
    }

    if (expirouTesteGestao && Number(moduloAtual) === 0) {
      return "/testeGestao";
    }

    if (podeTestarGestao && Number(moduloAtual) === 0) {
      return "/testeGestao";
    }

    return "";
  };

  const validarCaminho = (sessStorage, moduloAtual, caminhoAtual) => {
    const excessoes = [
      // excessoes que não possuem menu lateral (menu item)
      "inicio/",
      "editarPerfil",
      "403",
      "aplicativo",
      "meuPlano",
      "planos",
      "testeGestao",
      "/resgatarxml",
      "liberarAcesso",
      "faturas",
      "upgrade",
      "usuarios",
      "changelog",
      "novidades",
      "relatorios",
      "onboarding",
      "rastreabilidade-por-lote",
      "usuarios/notificacoes",
      "tickets",
      "mobile",
      "integracao",
      "seguranca",
      "dossieAutomatico",
      "consultas-automaticas",
      "mdfe",
      "parametros",
      "nf3e",
      "central-de-downloads",
    ];
    const caminhosGerais = excessoes.some((path) =>
      caminhoAtual.includes(path),
    );

    if (!caminhosGerais) {
      // if (duplicidadeCadastro) {
      //   return moduloAtual === 0 ? '/empresas' : '/resgate/empresas';
      // }

      if (contaBloqueada) {
        if (caminhoAtual.indexOf("liberarAcesso") === -1) {
          return "/liberarAcesso";
        }
      }

      if (primeiroAcesso) {
        if (
          caminhoAtual.indexOf("boasVindas") === -1 &&
          caminhoAtual.indexOf("planos") === -1
        ) {
          return "/inicio/boasVindas";
        }
      }

      if (!possuiEmpresas) {
        if (
          caminhoAtual.indexOf("resgate") === -1 &&
          caminhoAtual.indexOf("primeiraEmpresa") === -1 &&
          caminhoAtual.indexOf("plano") === -1
        ) {
          if (!possuiCertificado) {
            return "/inicio/tipoTeste";
          }
          return "";
        }
      }

      const items = sessStorage[10]?.[0]?.[moduloAtual]?.items || [];

      const possuiMenu = items.some((item) =>
        item.children?.some((child) => child.url === caminhoAtual),
      );

      if (!possuiMenu) {
        return "403";
      }

      const expirou = validaExpericao(moduloAtual);
      if (expirou) {
        return expirou;
      }
    }
    return "";
  };
  const { isLoggedIn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const moduloAtual = Number(localStorage.getItem("moduloAtual"));
  const [mfaValidated, setMfaValidated] = useState(false);

  // Quando o checkSessao periódico detectar MFA pendente no banco, força re-validação
  useEffect(() => {
    const handleMfaPending = () => setMfaValidated(false);
    window.addEventListener("mfa-pending", handleMfaPending);
    return () => window.removeEventListener("mfa-pending", handleMfaPending);
  }, []);

  const sessStorageRaw = sessionStorage.getItem("ddesp");
  const caminhoAtual = ObterCaminhoDaUrl(location.pathname);

  if (!isLoggedIn || !sessStorageRaw) {
    return <Redirect to="/auth/login" />;
  }

  const sessStorage = JSON.parse(base64_decode(sessStorageRaw));

  //34 dataacesso
  const dataAcesso = sessStorage[34]; //YYYY-MM-DD

// Compara a data de acesso (calculada pelo backend em America/Sao_Paulo)
// com "hoje" calculado NO MESMO FUSO, independente de onde o navegador do
// cliente está fisicamente. Isso evita que clientes em fusos muito
// diferentes do Brasil (ex: Índia, UTC+5:30) sejam deslogados incorretamente
// quando a data civil já virou no fuso deles mas ainda não virou em BRT.
  
  // en-CA formata em YYYY-MM-DD por padrão, útil para bater com o formato do backend
  // Isso calcula "hoje" no fuso de negócio, não no fuso do navegador do cliente
  const dataLocalFormatada = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
  }).format(new Date());

  if (!dataAcesso || dataAcesso !== dataLocalFormatada) {
    sessionStorage.clear();
    return <Redirect to="/auth/login" />;
  }

  if (!sessStorage[10] || !sessStorage[10][0]) {
    return <Redirect to="/auth/404" />;
  }

  if (sessStorage[10][0][1] === undefined) {
    sessionStorage.clear();
    window.location.href = "/auth/login";
    return null;
  }

  const redireciona = validarCaminho(sessStorage, moduloAtual, caminhoAtual);
  if (redireciona) {
    return <Redirect to={redireciona} />;
  }

  const qe = sessStorage[11][0].qe;
  if (sessStorage[8] === "1" && qe > 1) {
    if (
      location.pathname !== "/empresas" &&
      location.pathname !== "/resgate/empresas" &&
      !location.pathname.includes("/resgate/")
    ) {
      Swal.fire({
        title: "Atenção",
        text: "Seu plano permite apenas o cadastro de uma empresa ativa no módulo Gestão, remova as empresas não utilizadas para continuar usando o sistema normalmente.",
        icon: "warning",
      });
      history.push("/empresas");
      // return <Redirect to="/empresas" />;
    }
  }
  // ── Gate MFA pós-login ────────────────────────────────────────────────────
  const mfaInfo = sessStorage[36]; // [mfaEnabled, trusted, tempToken]
  const mfaEnabled = Array.isArray(mfaInfo) && mfaInfo[0] === true;
  const mfaTrusted = Array.isArray(mfaInfo) && mfaInfo[1] === true;
  const mfaTempToken = Array.isArray(mfaInfo) ? (mfaInfo[2] ?? null) : null;

  if (mfaEnabled && !mfaTrusted && !mfaValidated) {
    const userId = sessStorage[3];
    const email = sessStorage[6];
    const fingerprint = generateDeviceFingerprint() || "";

    const handleMfaSuccess = () => {
      // Atualiza [36] na sessão para não exibir gate novamente nesta sessão
      sessStorage[36] = [true, true, null];
      const { encode: base64_encode } = require("base-64");
      sessionStorage.setItem(
        "ddesp",
        base64_encode(JSON.stringify(sessStorage)),
      );
      setMfaValidated(true);
    };

    return (
      <MfaChallenge
        userId={userId}
        email={email}
        fingerprint={fingerprint}
        tempToken={mfaTempToken}
        onSuccess={handleMfaSuccess}
      />
    );
  }
  // ──────────────────────────────────────────────────────────────────────────

  return <>{children}</>;
};

export default AuthGuard;
